import { defineAIProviderManifest } from "../manifest";

export const manifest = defineAIProviderManifest({
  id: "openai-compatible",
  label: "Custom",
  description: "Connect to any OpenAI-compatible API endpoint.",
  connectorIdentifier: "apiKey",
  defaultChatModel: "chat-model",
  defaultFastModel: "fast-model",
  configurable: true,
  requiresChatModel: true,
  credentialFields: [
    {
      key: "baseUrl",
      label: "Base URL",
      description: "Required. Use your provider's API base URL.",
      placeholder: "https://llm.example.com/v1",
      required: true,
    },
    {
      key: "apiKey",
      label: "API key",
      description: "Stored securely on the server.",
      placeholder: "sk-…",
      sensitive: true,
    },
    {
      key: "caCertificate",
      label: "CA certificate",
      description:
        "Optional. Paste the PEM CA certificate used by this endpoint.",
      placeholder: "-----BEGIN CERTIFICATE-----\n…\n-----END CERTIFICATE-----",
      sensitive: true,
      multiline: true,
    },
  ],
  packCredentials: (v) => ({
    baseUrl: v.baseUrl?.trim() ?? "",
    apiKey: v.apiKey?.trim() ?? "",
    caCertificate: v.caCertificate?.trim() ?? "",
  }),
  unpackCredentials: (row) => ({
    baseUrl: row.baseUrl,
    apiKey: "",
    caCertificate: "",
  }),
  subtitleField: "baseUrl",
  attachmentSupport: {
    documentMediaTypes: ["application/pdf"],
    extensionToMediaType: { pdf: "application/pdf" },
  },
});
